import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da4012e4")

_pushScopeId("data-v-da4012e4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "comment-list-item" }
const _hoisted_3 = {
  key: 0,
  src: "/assets/noavatar.jpg",
  class: "avatar"
}
const _hoisted_4 = { class: "ion-margin-top" }
const _hoisted_5 = { class: "ion-margin-top" }
const _hoisted_6 = { class: "ion-margin-top" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_grid, { class: "page" }, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    size: "large",
                    icon: _ctx.arrowBack,
                    class: "ion-margin",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.go(-1)))
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "spacer" }),
              _createVNode(_component_ion_row, { class: "content-container ion-padding" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { size: "10" }, {
                    default: _withId(() => [
                      (_ctx.commentsVisible)
                        ? (_openBlock(), _createBlock("div", _hoisted_1, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.comments, (item) => {
                              return (_openBlock(), _createBlock("div", {
                                key: item.id
                              }, [
                                _createVNode("div", _hoisted_2, [
                                  (item.avatar == '')
                                    ? (_openBlock(), _createBlock("img", _hoisted_3))
                                    : (_openBlock(), _createBlock("img", {
                                        key: 1,
                                        src: item.avatar,
                                        class: "avatar"
                                      }, null, 8, ["src"])),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(item.comment), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-right",
                    size: "2"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_ion_icon, {
                          size: "small",
                          icon: _ctx.heart
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { color: "white" }, {
                          default: _withId(() => [
                            _createVNode("p", null, _toDisplayString(_ctx.likes), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_ion_icon, {
                          size: "small",
                          icon: _ctx.eye
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { color: "white" }, {
                          default: _withId(() => [
                            _createVNode("p", null, _toDisplayString(_ctx.views), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", _hoisted_5, [
                        _createVNode(_component_ion_icon, {
                          size: "small",
                          icon: _ctx.chatbox
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { color: "white" }, {
                          default: _withId(() => [
                            _createVNode("p", null, _toDisplayString(_ctx.commentCount), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_ion_icon, {
                          size: "small",
                          icon: _ctx.paperPlane,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleComments()))
                        }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.commentsVisible)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 0,
                    class: "comment-form"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_input, {
                        placeholder: "Your comment",
                        value: _ctx.comment,
                        onIonInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.comment = $event.target.value))
                      }, null, 8, ["value"]),
                      (_ctx.postingComment)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, {
                            key: 0,
                            name: "dots",
                            size: "small"
                          }))
                        : (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            size: "small",
                            icon: _ctx.paperPlane,
                            class: "ion-margin-start",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.postComment()))
                          }, null, 8, ["icon"]))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})